module.exports = __webpack_public_path__ + "img/harmonyOS_bg8.37bd1993.jpg";